module.exports = __webpack_public_path__ + "img/lens-160-minus-01.2b64b853.png";